(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-thumb]');
      var dots = gallery.querySelectorAll('[data-dot]');
      var medias = gallery.querySelectorAll('[data-media]');
      if (!main) return;

      // two_up reveals a pair at a time, so a thumb click moves a two-wide
      // window over the media list instead of selecting one image.
      var visibleCount = gallery.classList.contains('product-gallery--two_up') ? 2 : 1;

      function activate(index) {
        // Keep the window inside the list so the last thumb still fills the pair
        var start = Math.min(index, Math.max(medias.length - visibleCount, 0));
        function isVisible(i) {
          return i >= start && i < start + visibleCount;
        }

        medias.forEach(function (m, i) { m.classList.toggle('is-active', isVisible(i)); });
        thumbs.forEach(function (t, i) {
          t.classList.toggle('is-active', isVisible(i));
          t.setAttribute('aria-current', isVisible(i) ? 'true' : 'false');
        });
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === index);
          d.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { activate(i); });
      });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          activate(i);
          // Slides are exactly one viewport wide with no gap, so index * width
          // is the scroll offset — true for the carousel layout and for every
          // layout once the mobile breakpoint turns the main area into one.
          if (main.scrollWidth > main.clientWidth) {
            main.scrollTo({ left: i * main.clientWidth, behavior: 'smooth' });
          }
        });
      });

      // Sync dots with scroll. Attached for every layout, since all of them
      // become a swipeable carousel on mobile. A no-op while main can't scroll.
      if (dots.length) {
        main.addEventListener('scroll', function () {
          var width = main.clientWidth;
          if (!width) return;
          var index = Math.round(main.scrollLeft / width);
          dots.forEach(function (d, i) {
            d.classList.toggle('is-active', i === index);
            d.setAttribute('aria-selected', i === index ? 'true' : 'false');
          });
        }, { passive: true });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide-trigger"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('click', function (event) {
      var opener = event.target.closest && event.target.closest('[data-size-guide-open]');
      if (opener) {
        var dialog = document.querySelector('[data-size-guide]');
        if (!dialog) return;
        // showModal gives the focus trap and inert background; the fallback
        // keeps the guide reachable on anything that lacks dialog support.
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        return;
      }

      if (event.target.closest && event.target.closest('[data-size-guide-close]')) {
        var open = document.querySelector('[data-size-guide][open]');
        if (open) open.close ? open.close() : open.removeAttribute('open');
        return;
      }

      // Click on the backdrop — the dialog element itself, since the panel
      // covers everything inside it.
      if (event.target.matches && event.target.matches('[data-size-guide]')) {
        event.target.close ? event.target.close() : event.target.removeAttribute('open');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["skip-the-line"] && !Shopify.designMode) return;
  try {
    (function () {
    // One flight at a time: concurrent cart mutations race and can duplicate
    // the fee line.
    var pending = false;

    function post(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart request failed: ' + response.status);
        return response.json();
      });
    }

    // The cart page reloads on every line change, so match it there. Elsewhere
    // the drawer owns the re-render.
    function refresh(root) {
      var drawer = document.querySelector('cart-drawer');
      if (!root.closest('[data-cart-page]') && drawer && typeof drawer.refresh === 'function') {
        drawer.refresh();
        return;
      }
      window.location.reload();
    }

    function toggle(root, isOptingIn) {
      if (pending) return;
      pending = true;
      root.setAttribute('aria-busy', 'true');

      var shipsBy = root.dataset.shipsBy || '';
      var attributes = {};
      attributes[root.dataset.attributeLabel || 'Skip the Line'] = isOptingIn ? shipsBy : '';

      var request;
      if (isOptingIn) {
        var properties = {};
        properties[root.dataset.propertyLabel || 'Priority processing'] = shipsBy;
        request = post('/cart/add.js', {
          items: [{ id: parseInt(root.dataset.variantId, 10), quantity: 1, properties: properties }],
        });
      } else {
        request = post('/cart/change.js', { id: root.dataset.lineKey, quantity: 0 });
      }

      // The attribute is for merchant visibility only — never block on it.
      request
        .then(function () { return post('/cart/update.js', { attributes: attributes }); })
        .catch(function (error) { console.error('Skip the Line update failed', error); })
        .then(function () {
          pending = false;
          refresh(root);
        });
    }

    // A cart holding nothing but the fee would let someone check out with only a
    // service charge, so drop it once the last real item goes.
    function pruneOrphanFee() {
      if (pending) return;
      var root = document.querySelector('[data-skip-line]');
      if (!root) return;
      if (!root.dataset.lineKey) return;
      if (root.dataset.realItems !== '0') return;

      var attributes = {};
      attributes[root.dataset.attributeLabel || 'Skip the Line'] = '';

      pending = true;
      post('/cart/change.js', { id: root.dataset.lineKey, quantity: 0 })
        .then(function () { return post('/cart/update.js', { attributes: attributes }); })
        .catch(function (error) { console.error('Skip the Line cleanup failed', error); })
        .then(function () {
          pending = false;
          refresh(root);
        });
    }

    document.addEventListener('change', function (event) {
      if (!event.target || !event.target.closest) return;
      var input = event.target.closest('[data-skip-line-toggle]');
      if (!input) return;
      var root = input.closest('[data-skip-line]');
      if (root) toggle(root, input.checked);
    });

    document.addEventListener('cart:updated', pruneOrphanFee);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', pruneOrphanFee);
    } else {
      pruneOrphanFee();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.variants = JSON.parse(this.querySelector('[data-variant-data]').textContent);
      this.variantIdInput = this.querySelector('[data-variant-id-input]');
      this.inputs = this.querySelectorAll('input[type="radio"], select');
      this.inputs.forEach((input) => {
        input.addEventListener('change', () => this.onChange());
      });
    }

    onChange() {
      const selectedValues = Array.from(this.querySelectorAll('input[type="radio"]:checked, select')).map((el) => el.value);
      const match = this.variants.find((v) => v.options.every((opt, i) => opt === selectedValues[i]));
      if (!match) return;
      this.variantIdInput.value = match.id;
      this.updateSelectedLabel();
      this.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: match }, bubbles: true }));
      if (this.dataset.updateUrl === 'true' && history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    updateSelectedLabel() {
      this.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
        const position = input.dataset.optionPosition;
        const label = this.querySelector(`[data-selected-value="${position}"]`);
        if (label) label.textContent = input.value;
      });
    }
  }

  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', VariantPicker);
  }
  } catch(e) { console.error(e); }
})();

})();
